import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
//STYLED
import { down, up } from "styled-breakpoints"
import { H1, H4 } from "../../utils/typo"
import { ContainerMob } from "../../utils/utils"
//COMPONENTS

const Image = styled.div`
  width: 100%;
  height: auto;

  ${down("sm")} {
    display: none;
  }

  > div {
    width: 100%;
  }
`

const ImageMobile = styled.div`
  width: 100%;
  height: 85vh;
  margin-bottom: -6rem;

  > div {
    width: 100%;
    height: 100%;
  }

  ${up("md")} {
    display: none;
  }
`

const BanerWrapper = styled.div`
  background-color: transparent;
  position: relative;
  display: flex;
  flex-direction: column;
`

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  //justify-content: center;

  div {
    //align-items: ${props => props.align || "unset"};
  }

  h1 {
    width: 60%;

    ${down("sm")} {
      margin-top: 7rem;
      width: 100%;
    }
  }
`

const Baner = props => (
  <BanerWrapper>
    <Image>
      <GatsbyImage image={props.image} alt={props.alt || "Baner"} layout="" />
    </Image>

    <ImageMobile>
      <GatsbyImage image={props.image} alt={props.alt || "Baner"} />
    </ImageMobile>

    <Wrapper>
      <ContainerMob align={props.align === "right" ? "end" : "unset"}>
        <H1 mt="5rem" colorFont="white" textAlign={props.align}>
          {props.heading}
        </H1>
        <H4 weight="300" mt="2rem" colorFont="white">
          {props.intro}
        </H4>
      </ContainerMob>
    </Wrapper>
  </BanerWrapper>
)
export default Baner
